module.exports = __webpack_public_path__ + "static/media/Davos Seaworth.56013085.jpg";